// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import Typography from '@mui/material/Typography';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import KeyboardDoubleArrowDownRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowDownRounded';
import Link from '@mui/material/Link';
import MansionEstate from '@/types/components/MansionDetail/MansionEstate';
// Section for import custom components --------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
type NotificationForSaleProps = {
  mansionEstates: MansionEstate[];
};

// Section for render component ----------------------------------------------------------------------------------------
export default function NotificationForSale(props: NotificationForSaleProps) {
  const { mansionEstates } = props;
  let estateLink = '#app-content-detail-roomsForSale';
  if (mansionEstates.length === 1 && mansionEstates[0].com_url) {
    estateLink = mansionEstates[0].com_url;
  }

  const fvForSaleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // mansionEstates.length === 1の場合は通常のリンクとして動作
    if (mansionEstates.length === 1) {
      return;
    }

    e.preventDefault();
    const targetElement = document.getElementById('app-content-detail-roomsForSale-section');
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (mansionEstates.length === 0) return null;
  return (
    <Link
      href={estateLink}
      onClick={fvForSaleClick}
      target={mansionEstates.length === 1 ? '_blank' : undefined}
      rel={mansionEstates.length === 1 ? 'noopener noreferrer' : undefined}
      underline="none"
      className="flex items-center justify-center max-md:justify-between max-md:pl-5 max-md:pr-3 md:gap-x-4 h-12 text-white text-center cursor-pointer bg-rf-navy"
    >
      <Typography component="p" className="text-sm font-bold">
        売出し中の物件情報が
        <span className="px-2 max-md:px-1 text-base text-rf-yellow">{mansionEstates.length}</span>
        件あります
      </Typography>
      {mansionEstates.length === 1 ? <LaunchRoundedIcon /> : <KeyboardDoubleArrowDownRoundedIcon />}
    </Link>
  );
}
